import { createActionType } from '../core';
import { NAME } from './constants';

export const GET_USERS = createActionType(`${NAME}/GET_USERS`);
export const LOGIN_AS_USER = createActionType(`${NAME}/LOGIN_AS_USER`);
export const REVOKE_ALL_USER_SESSIONS = createActionType(`${NAME}/REVOKE_ALL_USER_SESSIONS`);
export const CLEAR_LOGIN_AS_USER = `${NAME}/CLEAR_LOGIN_AS_USER`;
export const UNBLOCK_USER = createActionType(`${NAME}/UNBLOCK_USER`);
export const GET_USER_ACTIVITIES = createActionType(`${NAME}/GET_USER_ACTIVITIES`);
export const GET_ALL_USERS = createActionType(`${NAME}/GET_ALL_USERS`);
export const GET_USER_NOTIFICATIONS = createActionType(`${NAME}/GET_USER_NOTIFICATIONS`);
export const CREATE_NOTIFICATION_FOR_ALL = createActionType(`${NAME}/CREATE_NOTIFICATION_FOR_ALL`);
export const CREATE_NOTIFICATION_FOR_USERS = createActionType(
    `${NAME}/CREATE_NOTIFICATION_FOR_USERS`
);
export const RESET_NEXT_REVIEW_DATE_FOR_USERS = createActionType(
    `${NAME}/RESET_NEXT_REVIEW_DATE_FOR_USERS`
);
export const UNLINK_COMRCE_OAUTH = createActionType(`${NAME}/UNLINK_COMRCE_OAUTH`);
export const DISABLE_TWO_FA = createActionType(`${NAME}/DISABLE_TWO_FA`);
